import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import investigatorImage from '../../../Assets/ResearchLabs/SSTRL/Director/rehan.png';

const { Link, Text, Title } = Typography;

const SstrlHead = () => (
  <section className="principal-investigator-section">
    <div className="investigator-content">
      <Title level={2} className="investigator-title">Principal Investigator/Lab Director</Title>
      <Divider className="ncgsa-divider" />
      <img className="investigator-photo" src={investigatorImage} alt="Dr. Rehan Mehmood" />
      <Text strong className="investigator-name">Dr. Rehan Mehmood</Text>
      <Text className="investigator-affiliation">IST, Islamabad</Text>
      <Link className="investigator-contact" href="mailto:rehan_59@hotmail.com">rehan_59@hotmail.com</Link>
      <Link className="investigator-contact" href="tel:+92519075483">Phone: 051-9075483</Link>
    </div>
  </section>
);

export default SstrlHead;
